import { reduxForm, change, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { CSSTransition } from 'react-transition-group'
import { Error } from '@myap/ui-library/cjs/components'
import {
  BIG_FUTURE_AND_CONNECTIONS_FORM,
  BIG_FUTURE_AND_CONNECTIONS_FIELDS as FIELDS,
} from '../../../constants/SetupConstants'
import { StepTracker, StepButtons } from '..'
import { Input } from '../../common'
import { finishCoordinatorSetup, getUserDetails } from '../../../actions/user'
import { changeStep, updateOrgSettings, fetchOrgSettings } from '../../../actions/settingsOrg'
import stylesheet from '../../../assets/style/scss/terms-and-conditions.scss'

const mapStateToProps = state => {
  const { selectedOrgId } = state.user.data
  const orgSettings = state.settingsOrg[selectedOrgId].data
  const { selectedEducationPeriod, availableEducationPeriods } = state.settingsEducationPeriod
  const selector = formValueSelector(BIG_FUTURE_AND_CONNECTIONS_FORM)
  return {
    orgSettings,
    selectedOrgId,
    selectedEducationPeriod,
    educationPeriod: availableEducationPeriods[selectedEducationPeriod]?.descr,
    initialValues: {
      [FIELDS.BFS_OPT_IN.name]: true,
      [FIELDS.CNX_OPT_IN.name]: true,
    },
    currentValues: {
      bfsOptIn: selector(state, FIELDS.BFS_OPT_IN.name),
      cnxOptIn: selector(state, FIELDS.CNX_OPT_IN.name),
    },
  }
}

const BigFutureAndConnections = ({ backStep, error, change, currentValues }) => {
  const handleBigFutureChange = e => {
    const newBfsValue = e.target.checked
    change(FIELDS.BFS_OPT_IN.name, newBfsValue)

    if (!newBfsValue) {
      change(FIELDS.CNX_OPT_IN.name, false)
    }
  }

  const handleConnectionsChange = e => {
    const newCnxValue = e.target.checked

    // Can only check Connections if Big Future is checked
    if (newCnxValue && !currentValues[FIELDS.BFS_OPT_IN.name]) {
      return
    }

    change(FIELDS.CNX_OPT_IN.name, newCnxValue)
  }

  return (
    <div>
      <StepTracker />
      <CSSTransition
        classNames="animate-fade"
        in={true}
        timeout={500}
        appear={true}
        enter={false}
        exit={false}
      >
        <div className="container" style={{ marginTop: 20 }}>
          {error ? <Error message={error} /> : null}
          <h2 className="h1">Big Future School and Connections</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
            exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p>
          <div className={`${stylesheet['tac-container']}`} style={{ height: '270px' }}>
            <h4 style={{ textDecoration: 'none', fontWeight: 'bold' }}>Big Future School</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat (&#34;AP
              Agreement&#34;).
            </p>
            <h4 style={{ textDecoration: 'none', fontWeight: 'bold' }}>Connections</h4>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus
              error sit voluptatem accusantium doloremque laudantium.
            </p>
            <Input
              type="checkbox"
              name={FIELDS.BFS_OPT_IN.name}
              onChange={handleBigFutureChange}
              label="I opt in to Big Future."
              isRequired={FIELDS.BFS_OPT_IN.required}
            />
            <Input
              type="checkbox"
              name={FIELDS.CNX_OPT_IN.name}
              onChange={handleConnectionsChange}
              disabled={!currentValues[FIELDS.BFS_OPT_IN.name]}
              label="I opt in to Connections."
              isRequired={FIELDS.CNX_OPT_IN.required}
            />
          </div>
          <div style={{ marginTop: 50 }}>
            <StepButtons
              backStep={backStep}
              form={BIG_FUTURE_AND_CONNECTIONS_FORM}
              buttonText="Save and Continue"
            />
          </div>
        </div>
      </CSSTransition>
    </div>
  )
}

export default connect(mapStateToProps, {
  updateOrgSettings,
  fetchOrgSettings,
  finishCoordinatorSetup,
  getUserDetails,
  changeStep,
  change,
})(
  reduxForm({
    form: BIG_FUTURE_AND_CONNECTIONS_FORM,
    onSubmit: (data, dispatch, { updateOrgSettings, orgSettings }) =>
      updateOrgSettings({
        ...orgSettings,
        bigFuture: {
          bfsOptIn: data[FIELDS.BFS_OPT_IN.name],
          cnxOptIn: data[FIELDS.CNX_OPT_IN.name],
          complete: true,
        },
      }),
    onSubmitSuccess: (
      data,
      dispatch,
      {
        finishCoordinatorSetup,
        fetchOrgSettings,
        selectedOrgId,
        selectedEducationPeriod,
        orgSettings,
        getUserDetails,
        changeStep,
      }
    ) => {
      changeStep(null)
      finishCoordinatorSetup(selectedOrgId, orgSettings.examAdministration.orderByAnotherSchool)

      // Fetch the org settings after saving because backend copies coordinator's
      // address into billing address and we want this to display on Settings Page.
      fetchOrgSettings(selectedOrgId, selectedEducationPeriod)

      // this clears the alarms icons throughout app as they are
      // populated with user.role data. This organization-info
      // saving does not automatically refresh the user details.
      getUserDetails()
    },
  })(BigFutureAndConnections)
)
